import React from "react";
import styled from "styled-components";
import {
    COLOR_BEER,
    COLOR_BLACK,
    COLOR_NEUTRAL_90,
    COLOR_WHITE,
} from "../../constants/color";
import {motion} from "framer-motion";
import logo from "../../images/icons/ch_k_logo_filled_transparent.png";
import logo_morava from "../../images/icons/ch_k_logo_filled_transparent_morava.png";


const EventSectionContainer = styled.div(() => ({
    backgroundImage: `url("https://chalihokilak.s3.eu-central-1.amazonaws.com/chalihokilakfotky/ch_k_skupinovka1.webp")`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundColor: COLOR_BEER,
    backgroundPosition: "center",
    display: "flex",
    flexDirection: "column",
    gap: 16,
    overflow: "hidden",
    padding: "64px",
    position: "relative",
    "@media (max-width: 800px)": {
        padding: "64px 32px 64px 32px",
    },
    "@media (max-width: 600px)": {
        padding: "64px 16px 64px 16px",
    },
}));

const EventSectionTextContainer = styled.div(() => ({
    display: "flex",
    flexDirection: "column",
    gap: 16,
}));

const EventSectionHeader = styled.div(() => ({
    color: COLOR_BLACK,
    fontSize: "3rem",
    fontWeight: "bold",
    marginBottom: 16,
    textAlign: "center",
    "@media (max-width: 800px)": {
        fontSize: "2.5rem",
    },
    "@media (max-width: 600px)": {
        fontSize: "2rem",
    },
}));

const EventSectionParagraph = styled.div(() => ({
    color: COLOR_WHITE,
    fontSize: "2rem",
    fontWeight: "bold",
    textAlign: "center",
    textShadow: "black 1px 5px 5px",
    "& span": {
        color: COLOR_BEER,
        fontWeight: "bolder",
    },
    "@media (max-width: 800px)": {
        fontSize: "1.5rem",
    },
    "@media (max-width: 600px)": {
        fontSize: "1rem",
    },
}));

const EventSectionParagraphDate = styled(motion.div)(() => ({
    color: COLOR_BEER,
    fontWeight: "bolder",
}));

const EventSectionRegistrationButtonContainer = styled.div(() => ({
    display: "flex",
    justifyContent: "center",
}));

const EventSectionRegistrationLink = styled(motion.a)(() => ({
    background: COLOR_BLACK,
    border: `3px solid ${COLOR_BLACK}`,
    borderRadius: 16,
    color: COLOR_WHITE,
    cursor: "pointer",
    fontSize: "1.5rem",
    fontFamily: "Courier New",
    fontWeight: "bold",
    padding: "16px 32px",
    textDecoration: "none",
    textAlign:"center",
    "@media (max-width: 800px)": {
        fontSize: "1rem",
    },
    "@media (max-width: 600px)": {
        fontSize: "0.8rem",
    },
}));

const EventSectionDatesContainer = styled.div(() => ({
    borderRadius: 16,
    display: "flex",
    justifyContent: "center",
    "@media (max-width: 800px)": {
        flexDirection: "column",
    },
}));

const EventSectionDateContainer = styled.div(props => ({
    display: "flex",
    padding: "16px 32px",
    border: `10px solid ${COLOR_NEUTRAL_90}`,
    borderRadius: props.borderRadius ? props.borderRadius : 0,
    "@media (max-width: 800px)": {
        borderRadius: props.borderRadiusMobile ? props.borderRadiusMobile : 0,
    },
    flexDirection: "column",
    alignItems: "center",
    gap: 8,
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    color: props.color ? props.color : COLOR_BEER,
    fontSize: "2rem",
    fontWeight: "bolder",
}));

const EventSectionCity = styled(motion.div)(() => ({
    color: COLOR_BLACK,
    fontSize: "2rem",
    fontWeight: "bold",
    marginBottom: 16,
    textAlign: "center",
    "@media (max-width: 800px)": {
        fontSize: "2rem",
    },
    "@media (max-width: 600px)": {
        fontSize: "1.6rem",
    },
}));

const EventSection = () => {

    return (
        <EventSectionContainer id="eventSection">
            <EventSectionTextContainer>
                <EventSectionHeader style={{color: COLOR_WHITE, textShadow: "black 1px 5px 5px",}}>AKCE 2026</EventSectionHeader>
                <EventSectionParagraph>
                    Oficiální termíny Chaliho kiláků jsou konečně tady!
                </EventSectionParagraph>
                <EventSectionParagraph>
                    Zapiš si do kalendáře:
                </EventSectionParagraph>
                <EventSectionDatesContainer>
                    <EventSectionDateContainer borderRadius={"16px 0 0 16px"} borderRadiusMobile={"16px 16px 0 0 "}>
                        <img src={logo} alt="Chaliho kilák logo" style={{height: 200, width: 200}}/>
                        <EventSectionCity>
                                Nepolisy
                        </EventSectionCity>
                        <EventSectionParagraphDate animate={{scale: [1, 1.1, 1, 1.1,1], rotate: [0,5,0,-5,0]}}
                                transition={{
                                    duration: 1,
                                    ease: "easeInOut",
                                    repeat: Infinity,
                                    repeatDelay: 4,
                                }} style={{WebkitTextStroke: "1px black", fontSize: "3rem"}} >20.6.2026</EventSectionParagraphDate>
            <EventSectionCity>
                Registrovat se
            </EventSectionCity>
            <EventSectionRegistrationButtonContainer>
                <EventSectionRegistrationLink
                    href={"https://docs.google.com/forms/d/e/1FAIpQLSc_v849BKe9QjzFlKeF0bdbKqFUl59oU3kJXjhJmRUZYrgsYQ/closedform"}
                    whileHover={{scale: 1.1}}
                    target={"_blank"}
                    rel={"noreferrer"}
                >

                    Hlavní běh + objednávka triček
                </EventSectionRegistrationLink>
            </EventSectionRegistrationButtonContainer>
            <EventSectionRegistrationButtonContainer>
                <EventSectionRegistrationLink
                    href={"https://docs.google.com/forms/d/e/1FAIpQLSfmGxK3JqYzKd3C4G3OnyCUcJjqrPRCcX_rnYgYepHrFr_B7A/viewform"}
                    whileHover={{scale: 1.1}}
                    target={"_blank"}
                    rel={"noreferrer"}
                >

                    Pivní hry
                </EventSectionRegistrationLink>
            </EventSectionRegistrationButtonContainer>
            <EventSectionRegistrationButtonContainer>
                <EventSectionRegistrationLink
                    href={"https://docs.google.com/forms/d/e/1FAIpQLScLBUh6CT1E3qYr242Oyd-x5GCYJ8IFGl4MbD0rWWcWT6D7Hg/viewform"}
                    whileHover={{scale: 1.1}}
                    target={"_blank"}
                    rel={"noreferrer"}
                >

                    Chali cup
                </EventSectionRegistrationLink>
            </EventSectionRegistrationButtonContainer>
                    </EventSectionDateContainer>
                    <EventSectionDateContainer borderRadius={"0 16px 16px 0"} borderRadiusMobile={"0 0 16px 16px"} color={"#00005f"}>
                        <img src={logo_morava} alt="Chaliho kilák logo Morava" style={{height: 200, width: 200}}/>
                        <EventSectionCity>Kunín</EventSectionCity>
                        <EventSectionParagraphDate animate={{scale: [1, 1.1, 1, 1.1,1], rotate: [0,-5,0,5,0]}}
                                transition={{
                                    duration: 1,
                                    ease: "easeInOut",
                                    repeat: Infinity,
                                    repeatDelay: 4,
                                    delay: 2, 
                                }}  style={{WebkitTextStroke: "1px black", fontSize: "3rem", color: "#00005f"}}>25.7.2026</EventSectionParagraphDate>
                    
            <EventSectionCity>
                Registrovat se
            </EventSectionCity>
            <EventSectionRegistrationButtonContainer>
                <EventSectionRegistrationLink
                    href={"https://docs.google.com/forms/d/1L3gDq50_BLnDP6VNYXxKaB53Ih9aDzDqBADv9eCHNnQ/closedform"}
                    whileHover={{scale: 1.1}}
                    target={"_blank"}
                    rel={"noreferrer"}
                >

                    Hlavní běh + objednávka triček
                </EventSectionRegistrationLink>

            </EventSectionRegistrationButtonContainer>  
            <EventSectionRegistrationButtonContainer>
                <EventSectionRegistrationLink
                    href={"https://docs.google.com/forms/d/e/1FAIpQLSc3YKaj3VoJLJ-TIFEpCbTc4h0mUkvCasKGxcgXcN6Q4GFb3Q/viewform?usp=header"}
                    whileHover={{scale: 1.1}}
                    target={"_blank"}
                    rel={"noreferrer"}
                >

                    Pivní hry
                </EventSectionRegistrationLink>
            </EventSectionRegistrationButtonContainer>
            <EventSectionRegistrationButtonContainer>
                <EventSectionRegistrationLink
                    href={"https://docs.google.com/forms/d/e/1FAIpQLSes54UTHETcVN-wmEL3ht55TtrzESYp6UDo8Y3chROG-CKplQ/viewform"}
                    whileHover={{scale: 1.1}}
                    target={"_blank"}
                    rel={"noreferrer"}
                >

                    Chali cup
                </EventSectionRegistrationLink>
            </EventSectionRegistrationButtonContainer> 
                    </EventSectionDateContainer>
                    
                </EventSectionDatesContainer>
                <EventSectionParagraph>
                    Minulý ročník byla skvělá jízda a jsme rádi, že vás akce stále baví stejně jako nás
                    a proto se snažíme posunout tento ročník zase o kousek dál. Proto si přijď zaběhnout kilák a dát u
                    toho
                    tři pivka i letos. Těšíme se na vás a sleduj naše sociální sítě ohledně dalších novinek!
                </EventSectionParagraph>
                <EventSectionParagraph>
                    Ještě ti nebylo 18? Nevadí, pro mladistvé máme připravená nealkoholická piva.
                </EventSectionParagraph>
            </EventSectionTextContainer>

            
        </EventSectionContainer>
    )
}

export default EventSection